import { Box, Paper, styled } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

const Paper1 = withDefaultProps(Paper, { elevation: 1 });
export const Container = styled(Paper1)`
  padding: ${({ theme }) => theme.spacing(3, 5)};
  margin: ${({ theme }) => theme.spacing(4, 0, 5)};
`;

export const ReadOnlyField = styled(Box)`
  margin-bottom: ${({ theme }) => theme.spacing(3)};

  .field-title {
    margin-bottom: ${({ theme }) => theme.spacing(1.5)};
    font-weight: 500;
  }
`;
